import React from "react";

export interface Prop {
    color?: string;
}

export const LinkedIn: React.FC<Prop> = ({ color = "#0065FF" }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.78353 4.16652C5.78331 4.60855 5.6075 5.03239 5.29478 5.34479C4.98207 5.6572 4.55806 5.83258 4.11603 5.83236C3.674 5.83214 3.25017 5.65633 2.93776 5.34361C2.62536 5.0309 2.44997 4.60688 2.4502 4.16486C2.45042 3.72283 2.62622 3.29899 2.93894 2.98659C3.25166 2.67419 3.67567 2.4988 4.1177 2.49902C4.55972 2.49924 4.98356 2.67505 5.29596 2.98777C5.60837 3.30049 5.78375 3.7245 5.78353 4.16652ZM5.83353 7.06652H2.5002V17.4999H5.83353V7.06652ZM11.1002 7.06652H7.78353V17.4999H11.0669V12.0249C11.0669 8.97486 15.0419 8.69152 15.0419 12.0249V17.4999H18.3335V10.8915C18.3335 5.74986 12.4502 5.94152 11.0669 8.46652L11.1002 7.06652Z"
                fill={color}
            />
        </svg>
    );
};

export const Facebook: React.FC<Prop> = ({ color = "#0065FF" }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.8332 2.39551C10.811 2.39551 9.83066 2.80157 9.10786 3.52437C8.38507 4.24716 7.979 5.22749 7.979 6.24967V8.39551H5.9165C5.81317 8.39551 5.729 8.47884 5.729 8.58301V11.4163C5.729 11.5197 5.81234 11.6038 5.9165 11.6038H7.979V17.4163C7.979 17.5197 8.06234 17.6038 8.1665 17.6038H10.9998C11.1032 17.6038 11.1873 17.5205 11.1873 17.4163V11.6038H13.2682C13.354 11.6038 13.429 11.5455 13.4498 11.4622L14.1582 8.62884C14.1651 8.60119 14.1657 8.57232 14.1598 8.54442C14.154 8.51651 14.1418 8.49032 14.1243 8.46782C14.1068 8.44532 14.0844 8.42712 14.0588 8.41459C14.0332 8.40205 14.005 8.39553 13.9765 8.39551H11.1873V6.24967C11.1873 6.16486 11.204 6.08088 11.2365 6.00252C11.269 5.92417 11.3165 5.85297 11.3765 5.793C11.4365 5.73303 11.5077 5.68546 11.586 5.653C11.6644 5.62055 11.7484 5.60384 11.8332 5.60384H13.9998C14.1032 5.60384 14.1873 5.52051 14.1873 5.41634V2.58301C14.1873 2.47967 14.104 2.39551 13.9998 2.39551H11.8332Z" fill={color} />
        </svg>
    );
};

export const Twitter: React.FC<Prop> = ({ color = "#0065FF" }) => {
    return (
        <svg viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" fill={color} />
        </svg>
    );
};